import { render, staticRenderFns } from "./AllBalance.vue?vue&type=template&id=e3663e38&scoped=true"
import script from "./AllBalance.vue?vue&type=script&lang=js"
export * from "./AllBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3663e38",
  null
  
)

export default component.exports